'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    gap: 16px;\n    flex-direction: ', ';\n'], ['\n    display: flex;\n    gap: 16px;\n    flex-direction: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    flex-shrink: 0;\n    appearance: none;\n    width: 20px;\n    height: 20px;\n    border: 1px solid ', ';\n    border-radius: 50%;\n    outline: none;\n\n    &:checked {\n        border: 6px solid ', ';\n    }\n\n    &:disabled {\n        border: 1px solid ', ' !important;\n    }\n'], ['\n    flex-shrink: 0;\n    appearance: none;\n    width: 20px;\n    height: 20px;\n    border: 1px solid ', ';\n    border-radius: 50%;\n    outline: none;\n\n    &:checked {\n        border: 6px solid ', ';\n    }\n\n    &:disabled {\n        border: 1px solid ', ' !important;\n    }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: ', ';;\n\n    &:not(:last-child) {\n        ', ';\n    }\n\n    &:hover {\n        & > input:not(:checked) {\n            border: 1px solid ', ';\n        }\n    }\n'], ['\n    display: flex;\n    align-items: ', ';;\n\n    &:not(:last-child) {\n        ', ';\n    }\n\n    &:hover {\n        & > input:not(:checked) {\n            border: 1px solid ', ';\n        }\n    }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    flex: 1;\n'], ['\n    flex: 1;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _label = require('../text/label');

var _label2 = _interopRequireDefault(_label);

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _sizes = require('../../constants/sizes');

var _colors = require('../../constants/colors');

var _getSize = require('../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _alignments = require('../../constants/alignments');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RadioContainer = (0, _styledComponents2.default)(_container2.default)(_templateObject, function (_ref) {
    var isMobile = _ref.isMobile,
        inline = _ref.inline;
    return isMobile || !inline ? 'column' : 'row';
});

var RadioComponent = _styledComponents2.default.input(_templateObject2, function (props) {
    return props.color || _colors.Colors.StrokeMedium;
}, _colors.Colors.Primary, _colors.Colors.StrokeLight);

var RadioComponentWrapper = _styledComponents2.default.div(_templateObject3, function (_ref2) {
    var inline = _ref2.inline;
    return inline ? 'center' : 'flex-start';
}, function (_ref3) {
    var inline = _ref3.inline;
    return inline && 'margin-right: ' + (0, _getSize2.default)(_sizes.Sizes.sm) + 'px;';
}, _colors.Colors.StrokeLight);

var Flex = _styledComponents2.default.div(_templateObject4);

var Radio = function (_React$Component) {
    _inherits(Radio, _React$Component);

    function Radio() {
        _classCallCheck(this, Radio);

        return _possibleConstructorReturn(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).apply(this, arguments));
    }

    _createClass(Radio, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.props.references && this.props.referencesEvent) {
                this.props.referencesEvent();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                _container2.default,
                { key: 'RadioInputLayout',
                    horizontalAlignment: _alignments.Alignments.left
                },
                this.props.label && _react2.default.createElement(
                    Flex,
                    null,
                    _react2.default.createElement(_label2.default, { textAlign: _alignments.Alignments.left,
                        text: this.props.label,
                        key: 'RadioLabel'
                    })
                ),
                _react2.default.createElement(
                    RadioContainer,
                    {
                        top: this.props.label && _sizes.Sizes.sm,
                        inline: this.props.inline,
                        isMobile: this.props.mobile,
                        fullSize: true
                    },
                    this.props.references && this.props.references.map(function (option, index) {
                        return _react2.default.createElement(
                            RadioComponentWrapper,
                            {
                                key: 'Radio' + index,
                                onClick: function onClick() {
                                    return _this2.props.changeEvent(option);
                                },
                                inline: _this2.props.inline
                            },
                            _react2.default.createElement(RadioComponent, {
                                key: 'option' + index,
                                type: 'radio',
                                disabled: _this2.props.disabled,
                                checked: _this2.props.value ? option.code === _this2.props.value.code : option.code === _this2.props.default,
                                value: option.code,
                                onChange: function onChange() {
                                    return _this2.props.changeEvent(option);
                                },
                                color: _this2.props.color
                            }),
                            _react2.default.createElement(_label2.default, { left: _sizes.Sizes.xs,
                                size: _this2.props.mobile ? _sizes.Sizes.md : _sizes.Sizes.lg,
                                textAlign: _alignments.Alignments.left,
                                text: option.value,
                                key: 'label' + index,
                                color: _this2.props.color || _colors.Colors.PrimaryText
                            })
                        );
                    })
                )
            );
        }
    }]);

    return Radio;
}(_react2.default.Component);

exports.default = Radio;